/* eslint-disable require-jsdoc */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-useless-escape */
// The module to be exported
// ported from sparta-validation-framework
function currency(amount, showCurrencySymbol, currencyCode) {
  /* defaults */
  var sCurrencySymbol = typeof showCurrencySymbol !== 'undefined' ? showCurrencySymbol : true;
  var sCurrencyCode = typeof currencyCode !== 'undefined' ? currencyCode : 'USD';
  var formattedAmount = '0.00';
  var currencySymbols = {
    USD: '$'
  };

  // Format the value, if it is not null, undefined, or empty
  if (amount) {
    formattedAmount = String(amount).replace(/[^\d\.-]/g, '');
    formattedAmount = parseFloat(formattedAmount).toFixed(2);
    var regexCommaDelimiterPattern = /^(-)?([^\.,-]+)(\d{3}[.,])/;
    while (regexCommaDelimiterPattern.test(formattedAmount)) {
      formattedAmount = formattedAmount.replace(regexCommaDelimiterPattern, '$1$2,$3');
    }
  }
  return "".concat(sCurrencySymbol ? "".concat(currencySymbols[sCurrencyCode], " ") : '').concat(formattedAmount);
}
export { currency };